import useInviteModal from './hooks/useInviteModal';
import InviteModalView from './view';

/**
 * InviteModal — the invitation a visitor sees when they land on a community
 * through a shared link (`?shared=true`) without being a member yet. Looks
 * like the community card: hero touching the surface's top corners, centered
 * logo + name, "{owner} is inviting you to join {name}", the three counters,
 * and a vertical stack of actions (join / decline) plus a floating close.
 *
 * @param {object}     community   the loaded community (from `community.load`)
 * @param {boolean}    open
 * @param {() => void} onClose     close / decline — the caller drops the URL param
 * @param {() => void} onJoined    fired after a successful join (communities already reloaded)
 */
export default function InviteModal({ community, open, onClose, onJoined }) {
    const state = useInviteModal({ community, onClose, onJoined });

    return <InviteModalView open={open} community={community} {...state} />;
}
